import { createContext, useContext } from 'react';

const UploadContext = createContext({
  isDisabled: false,
  onTriggerUpload: () => {}
});

export const UploadProvider = UploadContext.Provider;

export const useFileUpload = () => useContext(UploadContext);
